import React from 'react'
import './rombo-puntos-redeem.scss'

const RomboPuntosRedeem = ({ points }) => {
  const formatNumber = number => { 
    if (number === '0') return 0
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return 0
  }

  return (
    <span className="f-rombo-puntos-redeem">
      <b className="f-rombo-puntos-redeem__numero">{formatNumber(points)}</b>
    </span>
  )
}

export default RomboPuntosRedeem
